import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useNavigate, Link } from "react-router-dom";
import { Card, Form, Row, Col, Spinner, Modal } from "react-bootstrap";
import Select from "react-select";
import Swal from "sweetalert2";
import { BASE_URL } from "../../services/Api";
import { authHeader } from "../../services/auth-header";
import { IoIosClose } from "react-icons/io";
import { IoAdd, IoAddOutline } from "react-icons/io5";

const Company = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [companyname, setCompanyname] = useState("");
  const [contactperson, setcontactperson] = useState("");
  const [panno, setpanno] = useState("");
  const [workcontactno, setworkcontactno] = useState("");
  const [officecontactno, setofficecontactno] = useState("");
  const [gstno, setGstno] = useState("");
  const [email, setEmail] = useState("");
  const [address, setaddress] = useState("");
  const [address2, setaddress2] = useState("");
  const [country, setCountry] = useState(null);
  const [countryOptions, setCountryOptions] = useState([]);
  const [state, setState] = useState(null);
  const [stateOptions, setStateOptions] = useState([]);
  const [city, setCity] = useState(null);
  const [cityOptions, setCityOptions] = useState([]);
  const [zipcode, setzipcode] = useState("");
  const [statecode, setstatecode] = useState("");
  const [accountnumber, setaccountnumber] = useState("");
  const [bankname, setbankname] = useState("");
  const [branchname, setbranchname] = useState("");
  const [ifsccode, setifsccode] = useState("");
  const [policynumber, setpolicynumber] = useState("");
  const [policyvalidtill, setpolicyvalidtill] = useState("");
  const [cinno, setcinno] = useState("");
  const [lutno, setlutno] = useState("");
  const [udyamregistrationno, setudyamregistrationno] = useState("");
  const [iecno, setiecno] = useState("");
  const [incorporationdate, setincorporationdate] = useState("");

  // Validation states
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});

  const [companyMultipleAddresses, setCompanyMultipleAddresses] = useState([
    {
      address: "",
      country: null,
      state: null,
      statecode: "",
      city: null,
      zipcode: "",
    },
  ]);
  const [files, setFiles] = useState([]);
  const [fetchedImagesId, setFetchedImagesId] = useState([]);
  const [fetchedImages, setFetchedImages] = useState([]);
  const [showModel, setShowModel] = useState(false);
  const [currentDoc, setCurrentDoc] = useState(null);
  const [imagesidfordelete, setimagesidfordelete] = useState([]);

  // Capitalization function - accepts capital letters as well
  const capitalizeAllWords = (text) => {
    if (!text) return text;
    return text
      .split(' ')
      .map(word => {
        if (word.length === 0) return word;
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join(' ');
  };

  // Validation functions
  const validateField = (name, value) => {
    let error = "";

    switch (name) {
      case "companyname":
        if (!value || !value.trim()) {
          error = "Company Name is required";
        } else if (value.trim().length < 2) {
          error = "Company Name must be at least 2 characters";
        } else if (value.trim().length > 200) {
          error = "Company Name must be less than 200 characters";
        }
        break;

      case "contactperson":
        if (!value || !value.trim()) {
          error = "Contact Person is required";
        } else if (value.trim().length < 2) {
          error = "Contact Person must be at least 2 characters";
        } else if (value.trim().length > 100) {
          error = "Contact Person must be less than 100 characters";
        } else if (!/^[a-zA-Z\s]+$/.test(value.trim())) {
          error = "Contact Person should contain only letters and spaces";
        }
        break;

      case "email":
        if (!value || !value.trim()) {
          error = "Email is required";
        } else if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)) {
          error = "Please enter a valid email address";
        }
        break;

      case "workcontactno":
        if (value && value.trim() && !/^[0-9]{10}$/.test(value)) {
          error = "Work Contact No. must be a valid 10-digit number";
        }
        break;

      case "officecontactno":
        if (value && value.trim() && !/^[0-9]{10}$/.test(value)) {
          error = "Office Contact No. must be a valid 10-digit number";
        }
        break;

      case "gstno":
        if (value && value.trim() && !/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{3}$/.test(value)) {
          error = "Please enter a valid GST number (Format: 22AAAAA0000A1Z5)";
        }
        break;

      case "panno":
        if (value && value.trim() && !/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(value)) {
          error = "Please enter a valid PAN number (Format: ABCDE1234F)";
        }
        break;

      case "ifsccode":
        if (value && value.trim() && !/^[A-Z]{4}0[A-Z0-9]{6}$/.test(value)) {
          error = "Please enter a valid IFSC code (Format: SBIN0123456)";
        }
        break;

      case "accountnumber":
        if (value && value.trim() && !/^[0-9]{9,18}$/.test(value)) {
          error = "Account Number must be 9-18 digits";
        }
        break;

      case "cinno":
        if (value && value.trim() && !/^[A-Z]{1}[0-9]{5}[A-Z]{2}[0-9]{4}[A-Z]{3}[0-9]{6}$/.test(value)) {
          error = "Please enter a valid CIN number";
        }
        break;

      case "iecno":
        if (value && value.trim() && !/^[A-Z]{3}[0-9]{7}$/.test(value)) {
          error = "IEC No. must be 3 letters followed by 7 digits";
        }
        break;

      case "addressLine":
        if (value && value.trim() && value.trim().length < 5) {
          error = "Address must be at least 5 characters if provided";
        }
        break;

      case "zipcode":
        if (value && value.trim() && !/^[1-9][0-9]{5}$/.test(value)) {
          error = "Please enter a valid 6-digit pincode";
        }
        break;

      case "country":
        if (!value) error = "Country is required";
        break;

      case "state":
        if (!value) error = "State is required";
        break;

      case "city":
        if (!value) error = "City is required";
        break;

      default:
        break;
    }

    return error;
  };

  const handleBlur = (fieldName, value) => {
    setTouched(prev => ({ ...prev, [fieldName]: true }));
    const error = validateField(fieldName, value);
    setErrors(prev => ({ ...prev, [fieldName]: error }));
  };

  const handleAddressBlur = (index, fieldName, value) => {
    const addressTouchKey = `address_${index}_${fieldName}`;
    setTouched(prev => ({ ...prev, [addressTouchKey]: true }));

    let error = "";
    if (fieldName === "address") {
      error = validateField("addressLine", value);
    } else if (fieldName === "zipcode") {
      error = validateField("zipcode", value);
    } else if (fieldName === "country") {
      error = validateField("country", value);
    } else if (fieldName === "state") {
      error = validateField("state", value);
    } else if (fieldName === "city") {
      error = validateField("city", value);
    }

    const errorKey = `address_${index}_${fieldName}_error`;
    setErrors(prev => ({ ...prev, [errorKey]: error }));
  };

  // Improved validateAllFields function with detailed error collection
  const validateAllFields = () => {
    const newErrors = {};
    const errorFields = [];
    let isValid = true;

    // Required field validations
    const requiredFields = [
      { name: "companyname", value: companyname, label: "Company Name" },
      { name: "contactperson", value: contactperson, label: "Contact Person" },
      { name: "email", value: email, label: "Email" }
    ];

    for (const field of requiredFields) {
      const error = validateField(field.name, field.value);
      if (error) {
        newErrors[field.name] = error;
        errorFields.push(field.label);
        isValid = false;
      }
    }

    // Optional field validations (only if value is provided)
    const optionalFields = [
      { name: "workcontactno", value: workcontactno, label: "Work Contact No." },
      { name: "officecontactno", value: officecontactno, label: "Office Contact No." },
      { name: "gstno", value: gstno, label: "GST No." },
      { name: "panno", value: panno, label: "PAN No." },
      { name: "ifsccode", value: ifsccode, label: "IFSC Code" },
      { name: "accountnumber", value: accountnumber, label: "Account Number" },
      { name: "cinno", value: cinno, label: "CIN No." },
      { name: "iecno", value: iecno, label: "IEC No." }
    ];

    for (const field of optionalFields) {
      if (field.value && field.value.trim()) {
        const error = validateField(field.name, field.value);
        if (error) {
          newErrors[field.name] = error;
          errorFields.push(field.label);
          isValid = false;
        }
      }
    }

    // Validate addresses
    let hasValidAddress = false;
    companyMultipleAddresses.forEach((addr, idx) => {
      let addressHasError = false;

      // Check if at least one address has country, state, city
      if (addr.country && addr.state && addr.city) {
        hasValidAddress = true;
      }

      // Validate address line
      if (addr.address && addr.address.trim()) {
        const addressError = validateField("addressLine", addr.address);
        if (addressError) {
          newErrors[`address_${idx}_address_error`] = addressError;
          errorFields.push(`Address ${idx + 1} - Address Line`);
          addressHasError = true;
          isValid = false;
        }
      }

      // Validate zipcode
      if (addr.zipcode && addr.zipcode.trim()) {
        const zipError = validateField("zipcode", addr.zipcode);
        if (zipError) {
          newErrors[`address_${idx}_zipcode_error`] = zipError;
          errorFields.push(`Address ${idx + 1} - Zipcode`);
          addressHasError = true;
          isValid = false;
        }
      }

      // Country, State, City validation
      if (!addr.country) {
        newErrors[`address_${idx}_country_error`] = "Country is required";
        errorFields.push(`Address ${idx + 1} - Country`);
        addressHasError = true;
        isValid = false;
      }
      if (!addr.state) {
        newErrors[`address_${idx}_state_error`] = "State is required";
        errorFields.push(`Address ${idx + 1} - State`);
        addressHasError = true;
        isValid = false;
      }
      if (!addr.city) {
        newErrors[`address_${idx}_city_error`] = "City is required";
        errorFields.push(`Address ${idx + 1} - City`);
        addressHasError = true;
        isValid = false;
      }

      if (addressHasError) {
        errorFields.push(`Address ${idx + 1} fields`);
      }
    });

    if (!hasValidAddress && companyMultipleAddresses.length > 0) {
      isValid = false;
      errorFields.push("At least one complete address is required");
    }

    setErrors(newErrors);

    // Show detailed error message to user
    if (!isValid) {
      Swal.fire({
        icon: 'error',
        title: 'Validation Error',
        html: `<div style="text-align: left;">
          <strong>Please fix the following errors:</strong><br/><br/>
          ${errorFields.map(field => `• ${field}`).join('<br/>')}
        </div>`,
        confirmButtonText: 'OK'
      });
    }

    return isValid;
  };

  useEffect(() => {
    const fetch = async () => {
      try {
        const response = await axios.get(`${BASE_URL}company/findById/${1}`, {
          headers: authHeader(),
        });

        const Data = response.data;
        console.log("company data======>", Data);

        setpolicynumber(Data.policynumber);
        setpolicyvalidtill(Data.policyvalidtill);
        setCompanyname(Data.companyname);
        setworkcontactno(Data.workcontactno);
        setofficecontactno(Data.officecontactno);
        setGstno(Data.gstno);
        setEmail(Data.email);
        setcinno(Data.cinno);
        setlutno(Data.lutno);
        setudyamregistrationno(Data.udyamregistrationno);
        setiecno(Data.iecno);
        setincorporationdate(Data.incorporationdate);
        setcontactperson(Data.contactperson);
        setpanno(Data.panno);
        setstatecode(Data.statecode);
        setaccountnumber(Data.accountnumber);
        setbankname(Data.bankname);
        setbranchname(Data.branchname);
        setifsccode(Data.ifsccode);

        setFetchedImagesId(
          Data.companyImages.map((i) => ({
            id: i.id,
            name: i.filename,
            type: i.contenttype,
          }))
        );

        let addressData = await Promise.all(
          response.data.companyMultipleAddresses.map(async (i) => {
            let tempData = {
              address: i?.address,
              country: {
                value: i?.country?.id,
                label: i?.country?.countryname,
              },
              state: {
                value: i?.state?.id,
                label: i?.state?.statename,
                code: i?.state?.statecode,
              },
              statecode: i?.state?.statecode,
              city: { value: i?.city?.id, label: i?.city?.cityname },
              zipcode: i?.zipcode,
            };
            try {
              const stateResponse = await axios.get(
                BASE_URL + `state/stateByCountry/${i?.country?.id}`,
                {
                  headers: authHeader(),
                }
              );
              const cityResponse = await axios.get(
                BASE_URL + `city/cityByStateId/${i?.state?.id}`,
                {
                  headers: authHeader(),
                }
              );

              tempData.stateOptions = stateResponse?.data?.map((s) => ({
                value: s?.id,
                label: s?.statename,
              }));
              tempData.cityOptions = cityResponse?.data?.map((c) => ({
                value: c?.id,
                label: c?.cityname,
              }));
              return tempData;
            } catch (error) {
              console.log(error);
            }
          })
        );
        setCompanyMultipleAddresses(addressData);
        const countryResponse = await axios.get(
          BASE_URL + "country/findAllCountry",
          {
            headers: authHeader(),
          }
        );
        setCountryOptions(
          countryResponse.data.map((country) => ({
            value: country.id,
            label: country.countryname,
          }))
        );
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to fetch details. Please try again.",
        });
      }
    };

    fetch();
  }, [id]);

  useEffect(() => {
    if (fetchedImagesId.length > 0) {
      (async () => {
        let promises = fetchedImagesId.map(async (i) => {
          try {
            const response = await axios.get(
              BASE_URL + `companyImages/findById/${i.id}`,
              {
                headers: authHeader(),
                responseType: "blob",
              }
            );
            const contentType = response.headers["content-type"];
            const blob = new Blob([response.data], { type: contentType });
            const fileUrl = URL.createObjectURL(blob);
            return { src: fileUrl, name: i.name, type: i.type, id: i.id };
          } catch (error) {
            console.log("error in image fetch", error);
            Swal.fire({
              icon: "error",
              title: "Error",
              text: "Failed to fetch or open file. Please try again.",
            });
          }
        });
        const imageUrls = await Promise.all(promises);
        setFetchedImages(imageUrls);
      })();
    }
  }, [fetchedImagesId]);

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await axios.get(BASE_URL + "country/findAllCountry", {
          headers: authHeader(),
        });
        setCountryOptions(
          response.data.map((country) => ({
            value: country.id,
            label: country.countryname,
          }))
        );
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to fetch countries. Please try again.",
        });
      }
    };
    fetchCountries();
  }, []);

  const addAddress = () => {
    setCompanyMultipleAddresses([
      ...companyMultipleAddresses,
      {
        address: "",
        country: null,
        state: null,
        statecode: "",
        city: null,
        zipcode: "",
      },
    ]);
  };

  const removeAddress = (index) => {
    const newAddresses = companyMultipleAddresses.filter((_, i) => i !== index);
    setCompanyMultipleAddresses(newAddresses);
  };

  const handleAddressChange = (index, field, value) => {
    const newAddresses = [...companyMultipleAddresses];
    if (field === "address") {
      value = capitalizeAllWords(value);
    }
    newAddresses[index][field] = value;
    setCompanyMultipleAddresses(newAddresses);
  };

  const handleCountryChange = async (index, selectedOption) => {
    let data = [...companyMultipleAddresses];
    data[index].country = selectedOption;
    data[index].state = null;
    data[index].city = null;

    let stateOpt = [];

    try {
      const response = await axios.get(
        BASE_URL + `state/stateByCountry/${selectedOption?.value}`,
        {
          headers: authHeader(),
        }
      );

      stateOpt = response.data.map((state) => ({
        value: state.id,
        label: state.statename,
        code: state.statecode,
      }));
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to fetch states. Please try again.",
      });
    }
    data[index].stateOptions = stateOpt;
    setCompanyMultipleAddresses(data);
  };

  const handleStateChange = async (index, selectedOption) => {
    let data = [...companyMultipleAddresses];
    data[index].state = selectedOption;
    data[index].statecode = selectedOption?.code || "";
    data[index].city = null;
    let cityOpt = [];
    try {
      const response = await axios.get(
        BASE_URL + `city/cityByStateId/${selectedOption.value}`,
        {
          headers: authHeader(),
        }
      );
      cityOpt = response.data.map((city) => ({
        value: city.id,
        label: city.cityname,
      }));
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to fetch cities. Please try again.",
      });
    }
    data[index].cityOptions = cityOpt;
    setCompanyMultipleAddresses(data);
  };

  const handleSubmit = async () => {
    // Mark all fields as touched to show errors
    setTouched({
      companyname: true,
      contactperson: true,
      email: true,
      workcontactno: true,
      officecontactno: true,
      gstno: true,
      panno: true,
      ifsccode: true,
      accountnumber: true,
      cinno: true,
      iecno: true
    });

    // Validate all fields
    if (!validateAllFields()) {
      // Scroll to the first error field
      const firstErrorField = document.querySelector('.is-invalid');
      if (firstErrorField) {
        firstErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
        firstErrorField.focus();
      }
      return;
    }

    let formData = new FormData();
    let addressData = companyMultipleAddresses.map((i) => ({
      address: i?.address,
      country: { id: i?.country?.value },
      state: { id: i?.state?.value },
      statecode: String(i?.statecode),
      city: { id: i?.city?.value },
      zipcode: String(i?.zipcode),
    }));
    const companyData = {
      id: id,
      companyname,
      contactperson,
      panno,
      workcontactno,
      officecontactno,
      gstno,
      email,
      cinno,
      lutno,
      udyamregistrationno,
      iecno,
      incorporationdate,
      companyMultipleAddresses: addressData,
      accountnumber,
      bankname,
      branchname,
      ifsccode,
      policynumber,
      policyvalidtill,
      imagesidfordelete,
    };
    formData.append("company", JSON.stringify(companyData));
    if (files.length > 0) {
      files.forEach((file) => {
        formData.append("images", file);
      });
    } else {
      formData.append(
        "images",
        new Blob([], { type: "application/octet-stream" })
      );
    }

    try {
      const response = await axios.put(
        `${BASE_URL}company/update/${1}`,
        formData,
        {
          headers: authHeader(),
        }
      );
      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Company updated successfully!",
      });
      navigate("/company");
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response?.data || "Failed to update company",
      });
    }
  };

  const handleCurrentFileView = (index) => {
    setCurrentDoc(fetchedImages[index]);
    setShowModel(true);
  };

  const handleCloseFileView = () => {
    setCurrentDoc(null);
    setShowModel(false);
  };

  const handleDownload = () => {
    if (currentDoc) {
      const link = document.createElement("a");
      link.href = currentDoc?.src;
      link.download = currentDoc?.name;
      link.click();
    }
  };

  const handleAddFile = (event) => {
    const file = event.target.files[0];
    setFiles((prev) => [...prev, file]);
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      const imageObject = {
        src: imageUrl,
        name: file.name,
        type: file.type,
      };
      setFetchedImages((prevImages) => [...prevImages, imageObject]);
    }
  };

  const handleRemoveDocument = (index) => {
    const img = fetchedImages[index];
    if (img?.id) {
      setimagesidfordelete((prev) => [...prev, img?.id]);
    } else {
      setFiles(prev => [...prev].filter(i => i.name !== img?.name))
    }
    setFetchedImages(fetchedImages.filter((i, ind) => ind !== index));
  };

  return (
    <div className="Container">
      <Card className="card">
        <Card.Header className="card-header">
          <h6>COMPANY DETAILS EDIT</h6>
          <div className="view-buttons">
            <Link to={`/company`}>
              <button className="button-70">BACK</button>
            </Link>
          </div>
        </Card.Header>
        <Card.Body>
          <Form>
            <Row>
              <Col md="6">
                <Form.Group controlId="formcompanyname">
                  <Form.Label>Company Name <span className="text-danger">*</span></Form.Label>
                  <Form.Control
                    type="text"
                    value={companyname}
                    onChange={(e) => setCompanyname(capitalizeAllWords(e.target.value))}
                    onBlur={(e) => handleBlur("companyname", e.target.value)}
                    isInvalid={touched.companyname && !!errors.companyname}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.companyname}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group controlId="formcontactperson">
                  <Form.Label>Contact Person <span className="text-danger">*</span></Form.Label>
                  <Form.Control
                    type="text"
                    value={contactperson}
                    onChange={(e) => setcontactperson(capitalizeAllWords(e.target.value))}
                    onBlur={(e) => handleBlur("contactperson", e.target.value)}
                    isInvalid={touched.contactperson && !!errors.contactperson}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.contactperson}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group controlId="formworkcontactno">
                  <Form.Label>Work Contact No.</Form.Label>
                  <Form.Control
                    type="text"
                    value={workcontactno}
                    onChange={(e) => setworkcontactno(e.target.value.replace(/\D/g, '').slice(0, 10))}
                    onBlur={(e) => handleBlur("workcontactno", e.target.value)}
                    isInvalid={touched.workcontactno && !!errors.workcontactno}
                    maxLength="10"
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.workcontactno}
                  </Form.Control.Feedback>
                  <Form.Text className="text-muted">Optional: 10-digit number</Form.Text>
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group controlId="formofficecontactno">
                  <Form.Label>Office Contact No.</Form.Label>
                  <Form.Control
                    type="text"
                    value={officecontactno}
                    onChange={(e) => setofficecontactno(e.target.value.replace(/\D/g, '').slice(0, 10))}
                    onBlur={(e) => handleBlur("officecontactno", e.target.value)}
                    isInvalid={touched.officecontactno && !!errors.officecontactno}
                    maxLength="10"
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.officecontactno}
                  </Form.Control.Feedback>
                  <Form.Text className="text-muted">Optional: 10-digit number</Form.Text>
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group controlId="formemail">
                  <Form.Label>Email ID <span className="text-danger">*</span></Form.Label>
                  <Form.Control
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value.toLowerCase())}
                    onBlur={(e) => handleBlur("email", e.target.value)}
                    isInvalid={touched.email && !!errors.email}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.email}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>

              <Col md="6">
                <Form.Group controlId="formpanno">
                  <Form.Label>Pan Card No.</Form.Label>
                  <Form.Control
                    type="text"
                    value={panno}
                    onChange={(e) => setpanno(e.target.value.toUpperCase().slice(0, 10))}
                    onBlur={(e) => handleBlur("panno", e.target.value)}
                    isInvalid={touched.panno && !!errors.panno}
                    maxLength="10"
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.panno}
                  </Form.Control.Feedback>
                  <Form.Text className="text-muted">Format: ABCDE1234F (Optional)</Form.Text>
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group controlId="formgstno">
                  <Form.Label>GST No.</Form.Label>
                  <Form.Control
                    type="text"
                    value={gstno}
                    onChange={(e) => setGstno(e.target.value.toUpperCase().slice(0, 15))}
                    onBlur={(e) => handleBlur("gstno", e.target.value)}
                    isInvalid={touched.gstno && !!errors.gstno}
                    maxLength="15"
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.gstno}
                  </Form.Control.Feedback>
                  <Form.Text className="text-muted">Format: 22AAAAA0000A1Z5 (Optional)</Form.Text>
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group controlId="formpolicynumber">
                  <Form.Label>Insurance Policy Number</Form.Label>
                  <Form.Control
                    type="text"
                    value={policynumber}
                    onChange={(e) => setpolicynumber(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group controlId="formpolicyvalidtill">
                  <Form.Label>Policy Valid Till</Form.Label>
                  <Form.Control
                    type="date"
                    value={policyvalidtill}
                    onChange={(e) => setpolicyvalidtill(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group controlId="formcinno">
                  <Form.Label>CIN No.</Form.Label>
                  <Form.Control
                    type="text"
                    value={cinno}
                    onChange={(e) => setcinno(e.target.value.toUpperCase())}
                    onBlur={(e) => handleBlur("cinno", e.target.value)}
                    isInvalid={touched.cinno && !!errors.cinno}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.cinno}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group controlId="formlutno">
                  <Form.Label>LUT No.</Form.Label>
                  <Form.Control
                    type="text"
                    value={lutno}
                    onChange={(e) => setlutno(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group controlId="formudyamregistrationno">
                  <Form.Label>Udyam Registration No.</Form.Label>
                  <Form.Control
                    type="text"
                    value={udyamregistrationno}
                    onChange={(e) => setudyamregistrationno(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group controlId="formiecno">
                  <Form.Label>IEC No.</Form.Label>
                  <Form.Control
                    type="text"
                    value={iecno}
                    onChange={(e) => setiecno(e.target.value.toUpperCase())}
                    onBlur={(e) => handleBlur("iecno", e.target.value)}
                    isInvalid={touched.iecno && !!errors.iecno}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.iecno}
                  </Form.Control.Feedback>
                  <Form.Text className="text-muted">Format: ABC1234567 (Optional)</Form.Text>
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group controlId="formincorporationdate">
                  <Form.Label>Incorporation Date</Form.Label>
                  <Form.Control
                    type="date"
                    value={incorporationdate}
                    onChange={(e) => setincorporationdate(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group controlId="formaccountnumber">
                  <Form.Label>Account No.</Form.Label>
                  <Form.Control
                    type="text"
                    value={accountnumber}
                    onChange={(e) => setaccountnumber(e.target.value.replace(/\D/g, '').slice(0, 18))}
                    onBlur={(e) => handleBlur("accountnumber", e.target.value)}
                    isInvalid={touched.accountnumber && !!errors.accountnumber}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.accountnumber}
                  </Form.Control.Feedback>
                  <Form.Text className="text-muted">9-18 digits (Optional)</Form.Text>
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group controlId="formbankname">
                  <Form.Label>Bank Name</Form.Label>
                  <Form.Control
                    type="text"
                    value={bankname}
                    onChange={(e) => setbankname(capitalizeAllWords(e.target.value))}
                  />
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group controlId="formbranchname">
                  <Form.Label>Branch Name</Form.Label>
                  <Form.Control
                    type="text"
                    value={branchname}
                    onChange={(e) => setbranchname(capitalizeAllWords(e.target.value))}
                  />
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group controlId="formifsccode">
                  <Form.Label>IFSC Code</Form.Label>
                  <Form.Control
                    type="text"
                    value={ifsccode}
                    onChange={(e) => setifsccode(e.target.value.toUpperCase().slice(0, 11))}
                    onBlur={(e) => handleBlur("ifsccode", e.target.value)}
                    isInvalid={touched.ifsccode && !!errors.ifsccode}
                    maxLength="11"
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.ifsccode}
                  </Form.Control.Feedback>
                  <Form.Text className="text-muted">Format: SBIN0123456 (Optional)</Form.Text>
                </Form.Group>
              </Col>

              {companyMultipleAddresses.map((addr, index) => (
                <div
                  key={index}
                  style={{ marginTop: "20px", marginBottom: "10px" }}
                >
                  <card className="card" style={{ padding: "10px" }}>
                    <Form.Label>Company Address {companyMultipleAddresses.length > 1 ? index + 1 : ""}</Form.Label>
                    <Row className="rowmulti">
                      <Col md="12">
                        <Form.Group controlId={`formsupplieraddress${index}`}>
                          <Form.Label>Address Line:</Form.Label>
                          <Form.Control
                            type="text"
                            value={addr?.address}
                            onChange={(e) =>
                              handleAddressChange(
                                index,
                                "address",
                                e.target.value
                              )
                            }
                            onBlur={(e) => handleAddressBlur(index, "address", e.target.value)}
                            placeholder="Enter address line (Accepts capital letters)"
                            isInvalid={!!errors[`address_${index}_address_error`]}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors[`address_${index}_address_error`]}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md="4">
                        <Form.Group controlId={`formcountry${index}`}>
                          <Form.Label>Country: <span className="text-danger">*</span></Form.Label>
                          <Select
                            value={addr?.country}
                            onChange={(selectedOption) =>
                              handleCountryChange(index, selectedOption)
                            }
                            onBlur={() => handleAddressBlur(index, "country", addr?.country)}
                            options={countryOptions}
                            placeholder="Select country"
                            menuPortalTarget={document.body}
                            styles={{
                              menuPortal: base => ({ ...base, zIndex: 9999 })
                            }}
                          />
                          {errors[`address_${index}_country_error`] && (
                            <div className="text-danger" style={{ fontSize: '0.875rem', marginTop: '0.25rem' }}>
                              {errors[`address_${index}_country_error`]}
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md="4">
                        <Form.Group controlId={`formstate${index}`}>
                          <Form.Label>State: <span className="text-danger">*</span></Form.Label>
                          <Select
                            value={addr?.state}
                            onChange={(selectedOption) =>
                              handleStateChange(index, selectedOption)
                            }
                            onBlur={() => handleAddressBlur(index, "state", addr?.state)}
                            options={addr?.stateOptions}
                            placeholder="Select state"
                            isDisabled={!addr.country}
                            menuPortalTarget={document.body}
                            styles={{
                              menuPortal: base => ({ ...base, zIndex: 9999 })
                            }}
                          />
                          {errors[`address_${index}_state_error`] && (
                            <div className="text-danger" style={{ fontSize: '0.875rem', marginTop: '0.25rem' }}>
                              {errors[`address_${index}_state_error`]}
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md="4">
                        <Form.Group controlId={`formstatecode${index}`}>
                          <Form.Label>State Code:</Form.Label>
                          <Form.Control
                            type="text"
                            value={addr?.statecode}
                            readOnly
                          />
                        </Form.Group>
                      </Col>
                      <Col md="4">
                        <Form.Group controlId={`formcity${index}`}>
                          <Form.Label>City: <span className="text-danger">*</span></Form.Label>
                          <Select
                            value={addr?.city}
                            onChange={(selectedOption) =>
                              handleAddressChange(index, "city", selectedOption)
                            }
                            onBlur={() => handleAddressBlur(index, "city", addr?.city)}
                            options={addr?.cityOptions}
                            placeholder="Select city"
                            isDisabled={!addr.state}
                            menuPortalTarget={document.body}
                            styles={{
                              menuPortal: base => ({ ...base, zIndex: 9999 })
                            }}
                          />
                          {errors[`address_${index}_city_error`] && (
                            <div className="text-danger" style={{ fontSize: '0.875rem', marginTop: '0.25rem' }}>
                              {errors[`address_${index}_city_error`]}
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md="4">
                        <Form.Group controlId={`formzipcode${index}`}>
                          <Form.Label>Zipcode No.:</Form.Label>
                          <Form.Control
                            type="text"
                            value={addr?.zipcode}
                            onChange={(e) =>
                              handleAddressChange(
                                index,
                                "zipcode",
                                e.target.value.replace(/\D/g, '').slice(0, 6)
                              )
                            }
                            onBlur={(e) => handleAddressBlur(index, "zipcode", e.target.value)}
                            placeholder="Enter 6-digit pincode"
                            maxLength="6"
                            isInvalid={!!errors[`address_${index}_zipcode_error`]}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors[`address_${index}_zipcode_error`]}
                          </Form.Control.Feedback>
                          <Form.Text className="text-muted">Optional: 6-digit pincode</Form.Text>
                        </Form.Group>
                      </Col>
                      {companyMultipleAddresses?.length > 1 && (
                        <Col md="4">
                          <button
                            style={{
                              marginTop: "40px",
                              marginLeft: "px",
                              height: "38px",
                            }}
                            type="button"
                            onClick={() => removeAddress(index)}
                            className="btn btn-danger"
                          >
                            Remove
                          </button>
                        </Col>
                      )}
                    </Row>
                    <br />
                  </card>
                </div>
              ))}
              <Col md="12">
                <button
                  style={{ width: "250px", marginLeft: "0px" }}
                  type="button"
                  onClick={addAddress}
                  className="btn btn-primary mt-3 mb-3"
                >
                  + Add Another Address
                </button>
              </Col>

              <Row className="rowmulti">
                <Form.Label>Documents:</Form.Label>
                {fetchedImages.map((i, index) => {
                  return (
                    <Col md="2" className="" key={index} title={i.name}>
                      <div className="document-container">
                        <img
                          className="document-img"
                          src={
                            i.type === "application/pdf"
                              ? "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQFD8wlKNXDLaQd2isyyR0pzjfs3rhEoYcI19JN8mjTknETmghvZ_ux3Jr9RFvcZ4IXGmA&usqp=CAU"
                              : i.src
                          }
                          alt={i.name}
                        />
                        <div
                          className="close-icon-img"
                          onClick={(e) => handleRemoveDocument(index)}
                        >
                          <IoIosClose
                            style={{ color: "white", strokeWidth: "2rem" }}
                          />
                        </div>
                      </div>
                      <p className="p-2">
                        {i.name.length > 12
                          ? i.name.slice(0, 12) + "..."
                          : i.name}
                      </p>
                    </Col>
                  );
                })}
                <Col md="2" className="">
                  <label htmlFor="images" className="file-upload-label">
                    <div className="file-upload-icon-container">
                      <IoAddOutline size={50} />
                    </div>
                  </label>
                  <input
                    id="images"
                    type="file"
                    className="visually-hidden"
                    accept=".jpg, .jpeg, .png, .pdf"
                    onChange={handleAddFile}
                  />
                </Col>
              </Row>
            </Row>
            <button className="button-70" type="button" onClick={handleSubmit}>
              SUBMIT
            </button>
          </Form>
        </Card.Body>
      </Card>
    </div>
  );
};

export default Company;